import { useEffect, useRef } from 'react';

import IconButton from 'components/partials/button/icon-button';

import Icons from 'assets/icons';

interface RegimesSidebarToggleProps {
  isCollapsed: boolean;
  onToggle: () => void;
  /**
   * Focus the button right after mount. The button unmounts from the sidebar
   * header and remounts in the tab bar (and back) on every toggle, so without
   * this the keyboard focus is dropped to `<body>` after each activation.
   */
  focusOnMount?: boolean;
}

const RegimesSidebarToggle = ({
  isCollapsed,
  onToggle,
  focusOnMount,
}: RegimesSidebarToggleProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (focusOnMount) {
      buttonRef.current?.focus();
    }
  }, [focusOnMount]);

  return (
    <IconButton
      ref={buttonRef}
      variant="reserve-text"
      size="md"
      icon={<Icons.AiSidebarLeft aria-hidden="true" />}
      onClick={onToggle}
      aria-expanded={!isCollapsed}
      aria-label={
        isCollapsed ? 'Expand regimes sidebar' : 'Collapse regimes sidebar'
      }
      data-testid="regimes-sidebar-toggle"
    />
  );
};

export default RegimesSidebarToggle;
